// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "c55d4105763b15850c86c04fb23f8c5fd313a481/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"2a9a7941","581":"e1bbb2aa","688":"2b6b0509","774":"24c5a21d"}[chunkId] + ".chunk.js";
};